//frontend/src/components/CancelOrderDialog.js
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from '@mui/material';
import { cancelOrder } from '../services/api'; // <-- Add this API call

const CancelOrderDialog = ({ open, onClose, order, onCancelled }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleConfirm = async () => {
        setIsSubmitting(true);
        setError('');
        try {
          await cancelOrder(order.orderId);
          onCancelled();
          onClose();
        } catch (err) {
          console.error("Cancel failed:", err);
          
          // err could be { success: false, message: 'Only GiftOnly…' }
          const message = err?.message 
            || err?.response?.data?.message 
            || 'Error cancelling order.';
          setError(message);
          setIsSubmitting(false);
        }
      };
      

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Confirm Order Cancellation</DialogTitle>
            <DialogContent>
                <Stack spacing={1.5} sx={{ pt: 0.5 }}>
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                        Order: <Typography component="span" variant="body2" color="text.secondary">{order.orderNumber}</Typography>
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Cancel this order only if it should be removed from the fulfilment flow.
                    </Typography>
                    <Typography variant="body2">
                        This action cannot be undone.
                    </Typography>
                    {error && <Typography color="error" variant="body2">{error}</Typography>}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isSubmitting}>Close</Button>
                <Button
                    onClick={handleConfirm}
                    color="error"
                    variant="contained"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Cancelling Order...' : 'Confirm Cancellation'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default CancelOrderDialog;
